import React, { useState, useEffect, FC } from 'react'
import { getAvatar } from 'services/apiServices';
import { useNavigate } from "react-router-dom";
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import { Star } from 'lucide-react';

interface OneDaayTourCardProps {
  data: any;
  className?: string;
}

const OneDaayTourCard: FC<OneDaayTourCardProps> = ({ data, className = "" }) => {
  const [profileImg, setProfileImg] = useState("");
  
  const getProfile = async (filename: any) => {
    try {
      const profile: any = await getAvatar(filename);
      setProfileImg(URL.createObjectURL(profile))
    } catch (error) {
      setProfileImg('')
    }
  }

  useEffect(() => {
    getProfile(data.profileImg);
  }, [data.profileImg])

  const navGate = useNavigate()

  return (
    <div className={`nc-OneDaayTourCard group relative border border-gray-200 rounded-xl overflow-hidden bg-white shadow-md transition-all duration-300 hover:border-amber-500/50 hover:shadow-xl hover:shadow-amber-100 ${className}`}>
      <div className="relative w-full overflow-hidden">
        <div className="aspect-w-16 aspect-h-9 h-48 bg-gray-100">
          <img 
            src={profileImg || "/placeholder.svg"} 
            alt={data.package_name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-20"></div>
        </div>
      </div>

      <div className="p-6 space-y-4">
        <div className="space-y-2">
          <h2 className="font-bold text-lg text-gray-900 line-clamp-2 leading-tight">
            {data.package_name}
          </h2>
        </div>

        {data.rating && (
          <div className="flex items-center gap-2 py-3 border-t border-b border-gray-200">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-4 h-4 ${
                    i < Math.round(data.rating || 0)
                      ? "fill-amber-500 text-amber-500"
                      : "text-gray-300"
                  }`}
                />
              ))}
            </div>
            {data.reviewCount && (
              <span className="text-sm text-gray-500">({data.reviewCount})</span>
            )}
          </div>
        )}

        {data.price && (
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Starting at</span>
            <span className="text-xl font-bold text-amber-600">${data.price}</span>
          </div>
        )}

        <ButtonPrimary
          onClick={() => navGate(`/one-day-tour/view/${data.id}`)}
          className="w-full rounded-lg py-2.5 font-semibold transition-all duration-300 hover:shadow-lg"
        >
          View More
        </ButtonPrimary>
      </div>
    </div>
  )
}

export default OneDaayTourCard
